// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "clinic_setup".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "clinic_setup" table (1:1 with a DB row, on the wire). */
export const clinicSetupAtomSchema = z.object({
    opportunityId: z.string(),
    organizationId: z.string().nullable(),
    steps: z.unknown(),
    name: z.string().nullable(),
    businessName: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    websitePlatform: z.string().nullable(),
    hasWebsite: z.boolean().nullable(),
    websiteLoginEncrypted: z.string().nullable(),
    stripeCustomerId: z.string().nullable(),
    completedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=clinicSetup.js.map